import React, { useEffect, useLayoutEffect, useRef, useState, useCallback } from "react";
import { Info, List, UserPlus, AlertTriangle } from "react-feather";
import { useDispatch,  useSelector } from "react-redux";
import _ from "lodash";
import download from "downloadjs";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { base64 } from "../../constants/validate";
import { formatStatus, formatDate } from "../../constants/validate";
import env from "../../env";
import { Button, Chip, Tooltip } from "../DesignSystem";
import FinalizedProposal from "../../containers/Charge/components/FinalizedProposal";
import { Accordion } from "../Accordion";
import { useSnackbar } from "../../hooks/useSnackbar"
import Spinner from "../Spinner";
import PaymentCard from "../PaymentCard";
import LogTable from "../LogTable";

import ConfirmationModal from "../ConfirmationModal";

import Chat from "../Chat";

import "./index.scss";

function ProposalHistory({
  withInfoButton = false,
  withListButton = false,
  withShareButton = false,
  withoutCases = false,
  handleShowInfo,
  handleShowSidebar,
  isLoading = true,
  reloadProposal,
  fetchCases
}) {

  const dispatch = useDispatch();
  const {
    crm: { currentCase, proposalHistory, oldProposals },
    charge: { debtInfo, unpaidProposals },
  } = useSelector((state) => state);
  const caseInfo = _.isEmpty(currentCase) ? null : currentCase;
  const messagesContainerRef = useRef(null);
  const proposalHistoryRef = useRef(null);
  const [historyType, setHistoryType] = useState("");
  const [loading, setLoading] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const snackbar = useSnackbar()
  const [disabledClosedCaseId, setDisabledClosedCaseId] = useState('');
  const [currentCaseStatus, setCurrentCaseStatus] = useState('');
  const [logs, setLogs] = useState([]);


  const caseMode = currentCase?.case?.cases_types_id === 1 ? 'FINANCEIRO' : 'JUDICIAL'

  const observer = useRef(
    new ResizeObserver(() => {
      handleScrollProposalHistory();
    })
  );

  const setCurrentCase = useCallback(
    (data) => {
      // console.log("DATA -> ",data)
      dispatch({ type: "CHANGE_CURRENT_CASE", payload: data });
    },
    [dispatch]
  );


  const logTableHeaders = [
    "Alteração",
    "Data",
  ];
  
  const logTableObjectKeys = [
    "log_text",
    "log_created"
  ];
  
  useEffect(() => {
    if (proposalHistory.length === 1) {
      setHistoryType("accepted");
    } else {
      setHistoryType("active");
    }
  }, [proposalHistory]);

  useEffect(() => {
    if (currentCase?.case?.cnpj) {
      fetchLogs(currentCase.case.cnpj).then(setLogs);
    }
  }, [currentCase?.case?.cnpj]);

  useEffect(() => {
    if (currentCase?.case?.cases_types_id) {
      console.log(currentCase?.case?.cases_types_id);
    }
  }, [currentCase?.case?.cnpj]);

  useEffect(() => {
    setCurrentCaseStatus(currentCase?.case?.status)
  }, [currentCase?.case?.status]);

  useLayoutEffect(() => {
    const currentObserver = observer.current;
    const messasesContainerCurrent = messagesContainerRef.current;
    if (messasesContainerCurrent) {
      currentObserver.observe(messasesContainerCurrent);
    }

    return () => {
      currentObserver.disconnect();
    };
  }, [observer, isLoading]);

  async function fetchLogs(cnpj) {
    try {
      const response = await axios.post('/case/cases-logs', { cnpj });
      const logs = response.data;

      const formattedLogs = logs.map(log => {
        return {
          ...log,
          log_created: formatDate(log.log_created)
        };
      });
      console.log(formattedLogs);
      return formattedLogs;
    } catch (e) {
      console.error("Error fetching logs:", e);
      return [];
    }
  }

  function handleScrollProposalHistory() {
    if (messagesContainerRef.current && proposalHistoryRef.current) {
      proposalHistoryRef.current.scrollTop =
        messagesContainerRef.current.scrollHeight;
    }
  }

  function returnWrapperMessageClass(type) {
    let currentClassName = "proposal-history__wrapper-message";

    if (type === "card")
      currentClassName += " proposal-history__wrapper-message--card";

    return currentClassName;
  }

  function returnMessageClass(type) {
    let currentClassName = "proposal-history__message";

    if (type === "card") currentClassName += " proposal-history__message--card";

    return currentClassName;
  }

  function renderCards(item, index) {
    const valueInCash = Number(item[0].value);
    const lastItem = item[item.length - 1];
    const parts = Number(lastItem.number_installments);
    const lastInstallmentValue = Number(lastItem.value);
    let totalWithFees = item.length * item[item.length - 1].value;

    if (historyType === "accepted") {
      totalWithFees = parts * item[item.length - 1].value;
    } else {
      totalWithFees = item.length * item[item.length - 1].value;
    }

    if (historyType === "accepted") {
      return (
        <div key={index} className={returnWrapperMessageClass("card")}>

          <div className={returnMessageClass("card")}>
            <p>Proposta aceita</p>
            {parts === 1 ? (
              <PaymentCard
                type="toSelect"
                typePayment="À vista"
                way="Boleto bancário"
                total={valueInCash}
                minHeight="172px"
                unpaid={true}
                downloadMinute={() =>
                  currentCase.case.document_url
                    ? downloadSignedMinute()
                    : downloadMinute(item[0].id)
                }
                loading={loading}
              />
            ) : (
              <PaymentCard
                type="toSelect"
                typePayment="Parcelado"
                way="Boleto bancário"
                total={totalWithFees}
                entry={lastInstallmentValue}
                numberInstallments={parts}
                valueInstallments={lastInstallmentValue}
                minHeight="172px"
                unpaid={true}
                downloadMinute={() =>
                  currentCase.case.document_url
                    ? downloadSignedMinute()
                    : downloadMinute(item[0].id)
                }
                loading={loading}
              />
            )}
          </div>
        </div>
      );
    }

    return (
      <div key={index} className={returnWrapperMessageClass("card")}>
        <div className={returnMessageClass("card")}>
          <p>Proposta em negociação</p>
          <PaymentCard
            type="toSelect"
            typePayment="À vista"
            way="Boleto bancário"
            total={valueInCash}
            minHeight="172px"
          />
          <PaymentCard
            type="toSelect"
            typePayment="Parcelado"
            way="Boleto bancário"
            total={totalWithFees}
            entry={lastInstallmentValue}
            numberInstallments={parts}
            valueInstallments={lastInstallmentValue}
            minHeight="172px"
          />
        </div>
      </div>
    );
  }

  function renderHeaderIcons() {
    return (
      <div className="proposal-history__container-icons">

        {withShareButton && (
          <Button rounded onlyIcon>
            <Tooltip title="Compartilhar caso">
              <UserPlus size={20} />
            </Tooltip>
          </Button>
        )}
        {withListButton && (
          <Button rounded onlyIcon>
            <List size={20} onClick={handleShowSidebar} />
          </Button>
        )}
        {withInfoButton && (
          <Button rounded onlyIcon>
            <Info size={20} onClick={handleShowInfo} />
          </Button>
        )}
      </div>
    );
  }

  function closeModal() {
    setModalIsOpen(false);
  }
  function executed() {
    setModalIsOpen(true);
  }

  async function changeCaseStatus(statusId,parc, type, amount) {

    try {
      setLoading(true);

      // currentCase.case.status='CLOSED_CHAT'
      // setCurrentCase(currentCase)
      
      let body;
      let url;

      if(statusId !== 16 && caseMode === 'JUDICIAL') {
        const {data} = await axios.post('/case/change-status',{id:caseInfo?.case?.case_id, statusId})
        snackbar("Caso alterado.")
        setCurrentCaseStatus(data)
      }else {
        if(caseMode === 'JUDICIAL'){ 
          body = { caseId: caseInfo?.case?.case_id, parc, type, amount }
          console.log(body)

          url = '/case/add-agreement'
        }
        else {
          body = { id: caseInfo?.case?.case_id}
          url = '/case/executed'
        }

        await axios.post(url,body);
        if(caseMode === 'JUDICIAL'){ 
          await reloadProposal(caseInfo?.case?.cnpj)
        }
        setDisabledClosedCaseId(caseInfo?.case?.case_id);
        snackbar("Caso encerrado.")
        setCurrentCaseStatus('COSED_CHAT')
      }

      await fetchCases();            
      
    } catch (error) {
      console.error(error);
      snackbar("Houve um erro ao atualizar o caso")

    } finally {
      setLoading(false);
    }
  }

  function downloadMinute(id) {
    setLoading(true);
    axios
      .get(`/proposal/download-minute/${id}`)
      .then((response) => {
        const file = window.atob(response.data);
        download(file, `Minuta`, "application/pdf");
        setLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
      });
  }

  function downloadSignedMinute() {
    setLoading(true);
    let token =
      env === "development"
        ? "830b013e0b3a4112b20db7673bfb303d"
        : "93787308c6904130959e60dc4af0e379";
    let headers = { headers: { token } };

    window.open(currentCase.case.document_url);
    setLoading(false);

    /*axios
      .get(currentCase.case.document_url, headers)
      .then((response) => {
        download(
          base64(response.data.bytes, 'zip'),
          response.data.name,
          response.data.mimeType
        );
        setLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
      });*/
  }

  return (
    <div className="proposal-history">
      {isLoading && <Spinner size={24} containerHeight="100%" />}
      {!isLoading && withoutCases && (
        <header>
          <div className="header__without-cases">
            <p>Histórico - Nenhum caso encontrado</p>
          </div>

          {renderHeaderIcons()}
        </header>
      )}
      {!isLoading && !withoutCases && (
        <>
          <header>
            <div className="header__operator">
              <div className="header__operator__corporate_name">
                <Tooltip title={caseInfo?.case.corporate_name}>
                  {caseInfo?.case.corporate_name}
                </Tooltip>
              </div>
              <Button loading={loading} contained onClick={executed} disabled={caseInfo?.case.status === "CLOSED" || disabledClosedCaseId === caseInfo?.case?.case_id}>
                {caseMode === 'FINANCEIRO' ? 'Encerrar caso' : 'Alterar status'}
              </Button>
              <Chip outlined>{formatStatus(currentCaseStatus)}</Chip>
              <ConfirmationModal
                show={modalIsOpen}
                onClose={closeModal}
                onConfirmation={changeCaseStatus}
                message="Deseja realmente alterar o status do caso?"
                title="Altera status"
              />

            </div>

            {renderHeaderIcons()}

          </header>
          {caseInfo?.case.cases_types_id === 1 && (
            <section ref={proposalHistoryRef}>
              <p className="proposal-history__start-time">
                Negociação iniciada {formatDate(debtInfo?.created, false)}
              </p>
              {caseInfo?.case.integration_error === 1 && (
                <div className="proposal-history__billet-error">
                  <AlertTriangle /> Houve erro ao gerar um boleto vinculado
                </div>
              )}
              <div
                className="proposal-history__messages"
                ref={messagesContainerRef}
              >
                {/* {proposalHistory.map((item, index) => renderCards(item, index))} */}
                {proposalHistory.length > 0
                  ? renderCards(proposalHistory)
                  : "Nenhuma proposta ativa"}
              </div>
              {!_.isEmpty(oldProposals) && (
                <>
                  <div className="proposal-history__accordion">
                    {/* <Accordion title="Propostas arquivadas" align="right">
                      abc
                      <FinalizedProposal direction="column" />
                    </Accordion> */}
                    {unpaidProposals?.length > 0 && (
                      <>
                        <Accordion title="Propostas não pagas" align="right">
                          <FinalizedProposal direction="column" unpaid={true} />
                        </Accordion>
                      </>
                    )}
                  </div>
                </>
              )}
              {logs.length > 0 && (
                <div className="proposal-history__logs">
                  <LogTable headers={logTableHeaders} logs={logs} />
                </div>
              )}
            </section>
          )}

          {(caseInfo?.case?.cases_types_id === 2) && (
            // enfiar negócio pra dependendo do status (aguardando resposta == chat não abrir)
            <Chat caseId={currentCase?.case?.case_id}/>
            
          )}


        </>
      )}
    </div>
  );
}

export default ProposalHistory;
